<template>

  <div class="container-fluid">

    <BannerComponent title="BICIKL" subtitle="Biotic interactions browser" />

    <div class="row search-container" v-if="no_id">
      <h2>Search a document</h2>

      <div class="parameter-container">
        <label>Enter an identifier:</label><br />
        <select name="collection" id="collection" v-model="fetch_query.collection">
          <option v-for="(value, key, index) in collections" :key="'collection'+index" :value="key">{{ value }}</option>
        </select>
        <input type="text" required v-model.trim="fetch_query.doc_id" placeholder="identifier"/>
        
      </div>

      <ExecuteButton :disabled="to_disable" @click="queryByForm()" button_text="Search" />

    </div>
    <div class="row" v-show="showResultsClick || showResultsUrl">   
      <ResultsDocument ref="resultDocument" class="results" :doc_id="fetch_query.doc_id" :collection_name="fetch_query.collection" />
    </div>

  </div>

</template>

<script>

import BannerComponent from '@/components/BannerComponent.vue'
import ResultsDocument from '@/components/ResultsDocument.vue'
import ExecuteButton from '@/components/ExecuteButton.vue'
import { mapState, mapActions } from 'vuex'


export default {
  name: 'FetchPage',
  components: {
    BannerComponent,
    ResultsDocument,
    ExecuteButton
  },
  data() {
        return {
          showResultsUrl: false,
          showResultsClick: false,
        }
  },
  computed: {
        ...mapState(['theme_color', 'fetch_query', 'collections']),
        no_id(){
          if ('id' in this.$route.params && this.$route.params.id.length > 0){
            return false
          }
          return true
        },
        to_disable(){
          if (this.fetch_query.doc_id != ""){
            return false
          }
          return true;
        }
  },
  methods:{
    ...mapActions(['updateDocid', 'updateCollection']),
    queryByForm(){
      this.$matomo?.trackEvent("Fetch", this.fetch_query.doc_id+";"+this.fetch_query.collection);
      this.showResultsClick = false
      this.showResultsUrl = false
      this.$refs.resultDocument.fetchDocument()
      this.showResultsClick = true
      window.document.title = this.collections[this.fetch_query.collection]+" "+this.fetch_query.doc_id
    },
    queryByURL(){
      this.$matomo?.trackEvent("Fetch", this.fetch_query.doc_id+";"+this.fetch_query.collection);
      this.showResultsUrl = true
      this.$refs.resultDocument.fetchDocument()
      window.document.title = this.collections[this.fetch_query.collection]+" "+this.fetch_query.doc_id
    }
  },
  beforeMount() {
    this.showResultsUrl =false
    if ('id' in this.$route.params){
      this.updateDocid(this.$route.params.id)
    }
    if ('collection' in this.$route.params){
      this.updateCollection(this.$route.params.collection)
    }
  },
  mounted(){
    if (this.fetch_query.doc_id != ''){
      this.queryByURL()
    }
  },
  watch: {
        'fetch_query.doc_id': function(){
          this.showResultsClick = false
          if(this.no_id){
            this.showResultsUrl = false
          }
        },
        'fetch_query.collection': function(){
            this.showResultsClick = false
        },
      },
}

</script>

<style scoped lang="scss">

.search-container {
  background-color: #eee;
  margin: 50px;
}

    .container-fluid{
        padding-right: 0px;
        padding-left: 0px;
        margin-right: auto;
        margin-left: auto;
    }

    .row {
        padding: 50px;
        margin-left: 0;
        margin-right: 0;
    }

    .results {
      margin: 10px;
      text-align: left;
      border: 1px solid #ddd;
      padding: 15px 15px 0 15px;
    }

    .parameters-container {
        padding-bottom: 20px;
        text-align: left
    }
    .parameter-container {
        padding: 0 0 20px 0;
    }

    label {
        font-weight: bold;
    }

    input[type="text"] {
      width: 80%;
      padding-left: 10px;
      background-color: #fff;
      background-size: 30px;
      height: 40px;
      border: 1px solid grey;
      border-radius: 5px;
      font-size: 1.2em;
   }

   input[type="checkbox"] {

      margin-right: 10px;
      border: 1px solid grey;
   }

   select {
    background-color: #fff;
    width: 20%;
    border: 1px solid grey;
      border-radius: 5px;
      height: 40px;
   }

   .warning-container{
      background-color: lightgoldenrodyellow;
      padding: 10px;
      margin: 10px;
    }

</style>